import { _getTermFromHash } from '../initGlobal';

export function registerFaqFilter(Alpine) {
  Alpine.data('faqFilter', () => ({
    activeTerm: 'all-faqs',
    sel: {
      termLinks: '.terms-scroller a[href^="#"]',
      faqItems: '.list--faqs .faq-item', // details
      totalBox: '.list--total', // "총 N개" 표시 영역 (선택)
      termsWrap: '.list--terms', // 탭 UI (선택)
    },
    // cash
    _links: [],
    _items: [],
    _terms: [],
    _counts: {},

    init() {
      this._links = Array.from(this.$root.querySelectorAll(this.sel.termLinks));
      this._items = Array.from(this.$root.querySelectorAll(this.sel.faqItems));

      this._terms = this._links
        .map((a) => _getTermFromHash(a.getAttribute('href')))
        .filter(Boolean);

      this._counts = { all: this._items.length };
      this._terms.forEach((term) => {
        this._counts[term] = this._items.filter((el) =>
          el.classList.contains(`faq-${term}`)
        ).length;
      });

      const initial = _getTermFromHash(location.hash) || 'all-faqs';
      this.setTerm(initial, { pushHash: false });

      const termsContainer =
        this.$root.querySelector(this.sel.termsWrap) || this.$root;
      termsContainer.addEventListener('click', (e) => {
        const a = e.target.closest('a[href^="#"]');
        if (!a) return;
        const term = _getTermFromHash(a.getAttribute('href'));
        if (!term) return;
        e.preventDefault();
        this.setTerm(term, { pushHash: true, focusFirst: true });
      });

      // 해시 변경과 연동 (뒤로가기 등)
      window.addEventListener('hashchange', () => {
        const term = _getTermFromHash(location.hash);
        if (term) this.setTerm(term, { pushHash: false });
      });
    },
    setTerm(term, { pushHash = true, focusFirst = false } = {}) {
      this.activeTerm = term;

      if (pushHash) history.pushState(null, '', `#${term}`);

      this._links.forEach((a) => {
        const t = _getTermFromHash(a.getAttribute('href'));
        const isActive = t === term;
        a.classList.toggle('active', isActive);
        a.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      this._items.forEach((el) => {
        const visible =
          term === 'all-faqs' || el.classList.contains(`faq-${term}`);
        el.toggleAttribute('hidden', !visible);
      });

      // 총 개수 영역 갱신(선택)
      const box = this.$root.querySelector(this.sel.totalBox);
      if (box) {
        if (term === 'all-faqs') box.textContent = `총 ${this._counts.all}개`;
        else {
          const label =
            this._links
              .find((a) => a.getAttribute('href') === `#${term}`)
              ?.textContent.replace(/\(\d+\)/, '')
              .trim() || term;
          box.textContent = `${label} ${this._counts[term]}개`;
        }
      }

      // 첫 항목 포커스(선택): 키보드/스크린리더 편의
      if (focusFirst) {
        const first = this._items.find((el) => !el.hasAttribute('hidden'));
        first?.querySelector('summary')?.focus();
      }
    },
  }));
}
